import React, { useState, useEffect } from "react";
import { Col, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { SERVER_PATH } from "../../config/env";
import { Link } from "react-router-dom";
import { successToaster } from "./../../utils/index";
import apiClient from "../../utils/api";

export const POMcard = ({ serialNo }) => {
  const [selectOption, setSelectOption] = useState("select");
  const [productData, setProductData] = useState([]);
  const [data, setData] = useState([]);

  const fetchData = () => {
    apiClient.post(`get/all_products.php`, {}).then((res) => {
      setProductData(res.data);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const productFilter = productData.filter(
    (data) => selectOption === data.product_name
  );

  const selectPOM = async (productId) => {
    await apiClient
      .post(`put/product_of_month.php`, {
        s_no: serialNo,
        product_id: productId,
      })
      .then(() => {
        successToaster({ msg: "Product Selected Successfully" });
      });
  };

  return (
    <>
      <Col md={4} className="my-3">
        <h6 className="ms-1 text-secondary">Select The Product</h6>

        <Form.Select
          aria-label="Default select example"
          onChange={(e) => {
            const selectedOption = e.target.value;
            setSelectOption(selectedOption);
          }}>
          {productData.map((data) => {
            return (
              <option value={data?.product_name}>{data?.product_name}</option>
            );
          })}
        </Form.Select>
      </Col>
      <div className="row">
        {productFilter.map((data) => {
          return (
            <div className="col-lg-3 col-md-4 col-sm-6">
              <div
                className="card mb-4 product-wap rounded"
                style={{ minHeight: "350px" }}
              >
                <div className="card rounded-0">
                  <img
                    className="card-img rounded-0 img-fluid"
                    style={{
                      height: "160px",
                      objectFit: "contain",
                    }}
                    src={data.img1}
                    alt="Sri Mangalambika store products"
                  />
                </div>
                <div className="card-body">
                  <h5 className="text-uppercase" style={{ fontSize: ".9em" }}>
                    {data.product_name}&nbsp;
                    <small className="text-secondary text-capitalize">
                      {data.weight} Kg.
                    </small>
                  </h5>
                  <h6
                    className="text-secondary text-uppercase"
                    style={{ fontSize: ".8em" }}
                  >
                    {data.category}
                  </h6>
                  <span className="d-block text-success my-2">
                    RS.{data.offer_price}
                  </span>
                  <Button
                    className="btn btn-success btn-sm rounded-0 shadow-sm"
                    as={Link}
                    onClick={() => selectPOM(data.product_id)}
                  >
                    Select Product
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
